/* eslint-disable */
import React from "react";
import ImmotechComponent from "../../components/ImmotechComponent/ImmotechComponent";
import PaperComponent from "../../components/PaperComponent/PaperComponent";

export default function ImmotechPage() {
  return <><PaperComponent children={<ImmotechComponent />} /></>;
}
